var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommentPt1 = function SvgCommentPt1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.362 11.561 5.74 14.226c-.497.483-1.036.307-1.2-.373l-.129-2.382C2.465 11.052 1 9.224 1 7.03 1 4.527 2.907 2.5 5.26 2.5h5.48C13.091 2.5 15 4.528 15 7.03s-1.907 4.531-4.26 4.531z",
    clipRule: "evenodd"
  })));
};
export { SvgCommentPt1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNOS4zNjIgMTEuNTYxIDUuNzQgMTQuMjI2Yy0uNDk3LjQ4My0xLjAzNi4zMDctMS4yLS4zNzNsLS4xMjktMi4zODJDMi40NjUgMTEuMDUyIDEgOS4yMjQgMSA3LjAzIDEgNC41MjcgMi45MDcgMi41IDUuMjYgMi41aDUuNDhDMTMuMDkxIDIuNSAxNSA0LjUyOCAxNSA3LjAzcy0xLjkwNyA0LjUzMS00LjI2IDQuNTMxeiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";